import { Icon } from '@iconify/react';
import { Tabs, TabsList, TabsTrigger } from '@/components/shadcn/tabs';

export type PickleballStatistikTab = 'games' | 'standings';

interface PickleballStatistikTabsProps {
  tab: PickleballStatistikTab;
  onTabChange: (tab: PickleballStatistikTab) => void;
}

const TABS: { id: PickleballStatistikTab; label: string; icon: string }[] = [
  { id: 'games', label: 'Pertandingan', icon: 'mdi:tennis' },
  { id: 'standings', label: 'Klasemen', icon: 'mdi:format-list-numbered' },
];

export default function PickleballStatistikTabs({ tab, onTabChange }: PickleballStatistikTabsProps) {
  return (
    <Tabs value={tab} onValueChange={(value) => onTabChange(value as PickleballStatistikTab)}>
      <TabsList className="h-auto w-full justify-start gap-2 overflow-x-auto bg-transparent p-0">
        {TABS.map((item) => (
          <TabsTrigger
            key={item.id}
            value={item.id}
            className="rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-400 shadow-none data-[state=active]:border-[#FC480D] data-[state=active]:bg-white data-[state=active]:text-[#FC480D] data-[state=active]:shadow-none"
          >
            <Icon icon={item.icon} className="h-4 w-4" />
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
